import React from 'react'
import ReactDOM from 'react-dom'
import './assets/scss/global.scss'
import i18n from './i18n'
import { I18nextProvider } from 'react-i18next'
import App from './App'
import { Provider } from 'react-redux'
import { LastLocationProvider } from 'react-router-last-location'
import store, { history, persistor } from './Store'
import { Router } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import TagManager from 'react-gtm-module'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import { theme } from './theme'
import * as Sentry from '@sentry/browser'
import { BackgroundChecks } from './components'

const GlobalStyle = createGlobalStyle`
  html, body {
    font-family: ${({ theme }) => `${theme.fontStack};`}
  }
`

if (process.env.REACT_APP_SENTRY) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY,
    integrations: [
      new Sentry.Integrations.GlobalHandlers({
        onerror: true,
        onunhandledrejection: false,
      }),
    ],
  })
}

if (process.env.REACT_APP_GTM) {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM,
  }
  TagManager.initialize(tagManagerArgs)
}

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18n}>
          <React.Fragment>
            <GlobalStyle />
            <Router history={history}>
              <LastLocationProvider>
                <App />
                <BackgroundChecks />
              </LastLocationProvider>
            </Router>
          </React.Fragment>
        </I18nextProvider>
      </PersistGate>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root'),
)



// WEBPACK FOOTER //
// ./src/index.js